import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createTheme, hexToRgb, responsiveFontSizes } from '@mui/material/styles';

const GetTheme = () => {
    //const prefersDarkMode = useMediaQuery("(prefers-color-scheme: light)");
    return responsiveFontSizes(createTheme({
        typography: {
            fontFamily: 'Quicksand, Helvetica, sans-serif, Arial',
            h1: {
                fontSize: 40,
                fontWeight: "bold",
            },
            h2: {
                fontSize: 20,
                fontWeight: "bold",
            },
            h3: {
                fontSize: 15,
                fontWeight: "bold",
            },
            h4: {
                fontSize: 13,
                fontWeight: "bold",
            },
            div: {
                fontSize: 12,
                fontWeight: "normal",
            }
        },
        palette: {
            primary: {
                main: '#00796b',
            },
            secondary: {
                main: '#004A79',
            },
            error: {
                main: '#794a00'
            },
            mode: 'light',
        },
        components: {
            MuiTypography: {
                styleOverrides: {
                    body1: {
                        fontWeight: "600"
                    },
                    body2: {
                        fontWeight: "500"
                    }
                }
            },
            MuiGrid: {
                styleOverrides: {
                    root: {
                        textDecoration: 'none',
                        fontFamily: 'Quicksand, Helvetica, sans-serif, Arial',
                    },
                },
            },
            MuiInputBase: {
                defaultProps: {
                    disableInjectingGlobalStyles: true,
                },
            },
        },
  }));
}

export default GetTheme;
